import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishUSA from "./localization/en-us.json";
import frenchCAN from "./localization/fr-ca.json";
import englishCA from "./localization/en-ca.json";

// the translations
const resourceContent = {
  "en-US": {
    translation: englishUSA,
  },
  "en-CA": {
    translation: englishCA,
  },
  "fr-CA": {
    translation: frenchCAN,
  },
};
i18n
  // passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    // "en" | "es"
    lng: i18n.language,
    fallbackLng: "en-US",
    resources: resourceContent,
    keySeparator: true,
  });

export default i18n;
